import React from "react";

const CustomCheckbox = ({ label, checked, onChange }) => {
    return (
        <div
            className={`custom-checkbox-container ${checked ? "checked" : ""}`}
        >
            <div className="custom-checkbox" onClick={() => onChange(!checked)}>
                {checked && <div className="custom-checkbox-check"></div>}
            </div>
            <span className="custom-checkbox-label">{label}</span>
        </div>
    );
};

export default CustomCheckbox;
